import React, { Component } from 'react';
import styles from './style.scss';
import IconComponent from '../../../portal/iconComponent';
import { inject } from 'mobx-react';
import { FormWrapper } from '@checkmarx/cx-ui';
import PermissionsCategory from './permissionsCategory';
import { sort } from '../../../../services/utils';

@inject('translationsStore')
export default class OpenServiceProvider extends Component {

    selectAll = () => {
        
        this.props.categories.forEach(category => {
            category.data.forEach(permission => {
            
                    this.props.rolesStore.setPermissionId(permission.id);
            });
        });
    }
    
    clearAll = () => {
        
        this.props.categories.forEach(category => {
            category.data.forEach(permission => {
            
                this.props.rolesStore.removePermissionId(permission.id);
            });
        });
    }

  fixManageUserDisplayName = (categories) => {
    categories.forEach((cat) => {
      const perm = cat.data.find((perm) => perm.name === 'manage-users');
      if(perm) perm.name = 'manage-users-and-teams';
    });
  }
    
    render() {

        const categories = sort(this.props.categories)('name')('asc');
        this.fixManageUserDisplayName(categories);
        
        
        return (
            <FormWrapper>
                        <div
                            className={styles.permissionsGroupHeader}
                        >
                            <div className={styles.iconWrapper}>
                            <IconComponent iconClassName='minus-large-icon' onClick={this.props.onCloseServiceProvider} />
                            </div>
                            <div>
                                <div className={styles.permissionsGroupHeaderTitle}>
                                    {this.props.serviceProviderName}
                                </div>
                                <div className={styles.permissionsGroupHeaderSubTitle}>
                                    {this.props.permissionsCount} {this.props.translationsStore.translate('PERMISSIONS_SELECTED')}
                                </div>
                            </div>
                            <div className={styles.permissionsGroupHeaderButtons}>
                                <span className='portal-blank-button link' onClick={this.selectAll}>
                                    { this.props.translationsStore.translate('SELECT_ALL') }
                                </span>
                                <span className='portal-blank-button link' onClick={this.clearAll}>
                                    { this.props.translationsStore.translate('CLEAR_ALL') }
                                </span>
                            </div>
                        </div>
                        <div className={styles.permissionSeperator}></div>
                        <div
                            className={styles.permissionCategory}
                        >
                            {
                                categories.map(category => {
                                    return <PermissionsCategory key={category.catId} category={category}/>;
                                })
                            }
                        </div>
                    </FormWrapper>
        );
    }
}
